export const NavigationExpandedWidth = 192;
export const NavigationCollapsedWidth = 72;
export const SidebarWidth = 328;
export const SidebarWidthMobile = 200;
